import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { internalFeedbackData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function InternalFeedbackPage() {
    return <SolutionTemplate {...internalFeedbackData} />;
}
